"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const immutable_1 = require("immutable");
const Node_1 = require("../Node");
const utils_1 = require("../utils");
const Rule_1 = require("../Rule");
const Transformation_1 = require("../Transformation");
// fib=[
//   fib(0)=0,
//   fib(1)=1,
//   fib($a)=fib($a-1)+fib($a-2) if const($a)
// ]
const name = 'fib';
exports.fibonaccify = utils_1.generateOperator(name);
const fibonacci = new Transformation_1.default(name, immutable_1.List([
    new Rule_1.default(exports.fibonaccify(new Node_1.Num(0)), new Node_1.Num(0)),
    new Rule_1.default(exports.fibonaccify(new Node_1.Num(1)), new Node_1.Num(1)),
    new Rule_1.default(exports.fibonaccify(new Node_1.Rewritable('a')), utils_1.plus(exports.fibonaccify(utils_1.minus(new Node_1.Rewritable('a'), new Node_1.Num(1))), exports.fibonaccify(utils_1.minus(new Node_1.Rewritable('a'), new Node_1.Num(2)))), utils_1.constant(new Node_1.Rewritable('a'))),
]));
exports.default = fibonacci;
//# sourceMappingURL=fibonacci.js.map